// Field keys that should be displayed as full mask (e.g. password, OTP)
export const FULL_MASK_FIELDS = new Set([
  'password',
  'static_otp',
  'totp_secret_code',
  'secret_word',
]);

export const CREDIT_CARD_FIELD_KEY = 'credit_card';

/**
 * Returns display string for credit card value (last 4 digits visible).
 * @param {string} value - Raw value
 * @returns {string}
 */
export function getCreditCardMask(value) {
  const digits = `${value}`.replace(/\D/g, '');
  if (!digits) {
    return '****';
  }
  const lastFourDigits = digits.slice(-4);
  return `**** ${lastFourDigits}`;
}

/**
 * Returns display value for a field (masked or plain).
 * @param {{ value?: string, fieldType?: string }} field
 * @param {Set<string>} fullMaskFields
 * @param {string} creditCardFieldKey
 * @returns {string}
 */
export function getMaskedValue(
  field,
  fullMaskFields = FULL_MASK_FIELDS,
  creditCardFieldKey = CREDIT_CARD_FIELD_KEY
) {
  const value = field.value || '';
  if (!value) {
    return 'No value';
  }
  if (field.fieldType === creditCardFieldKey) {
    return getCreditCardMask(value);
  }
  if (fullMaskFields.has(field.fieldType)) {
    return '********';
  }
  return value;
}
